var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createApp } from "vue";
import FilterApp from './FilterApp.vue';
import { createPinia } from "pinia";
import { useFilterStore } from "./store";
import { updateHtml } from "../../components/pager";
import useFilterAPI from "./api";
import EventBus from "../../events/EventBus";
import { extractAppData } from "../../utils";
import { switchTabByCode } from "../../components/ajax_tabs";
import { initSetConstructor } from "../sets_constructor";
var filterEl = document.getElementById('filter-app');
var titleEl = document.querySelector('h1');
var constructorEl = filterEl === null || filterEl === void 0 ? void 0 : filterEl.querySelector('.constructor-set-box');
var notFoundMessage = document.getElementById('not-found-block');
function updateErrorMessage(show, isNew) {
    if (show) {
        notFoundMessage.querySelector('span[data-text-1]').innerText = isNew ? 'новых товаров' : 'товаров со скидкой';
        notFoundMessage.querySelector('span[data-text-2]').innerText = isNew ? 'новинки от других брендов' : 'самые популярные ароматы в нашей распродаже';
        notFoundMessage.classList.remove('hidden');
    }
    else {
        notFoundMessage.classList.add('hidden');
    }
}
function updatePageTitle(title) {
    if (title) {
        document.title = titleEl.innerText = title;
    }
}
export default function initFilter() {
    return __awaiter(this, void 0, void 0, function () {
        var initialState, html, pagerHtml, title, pinia, store, api, isConstructor, setConstructorProps, state, e_1;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    initialState = extractAppData(filterEl);
                    if (!filterEl || !initialState) {
                        return [2 /*return*/];
                    }
                    html = (_a = document.querySelector('.catalog_items')) === null || _a === void 0 ? void 0 : _a.innerHTML;
                    pagerHtml = (_b = document.querySelector('[data-pagination]')) === null || _b === void 0 ? void 0 : _b.innerHTML;
                    title = titleEl.innerText;
                    pinia = createPinia();
                    store = useFilterStore(pinia);
                    api = useFilterAPI();
                    isConstructor = !!(constructorEl && initialState.setDraft);
                    setConstructorProps = isConstructor ? initSetConstructor(initialState.setDraft) : {};
                    store.setInitialState(initialState);
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, api.request('/api/filter/state')];
                case 2:
                    _e.sent();
                    store.setLoaded(false);
                    createApp(FilterApp, __assign({ currentSort: (_d = (_c = document.getElementById('sorting')) === null || _c === void 0 ? void 0 : _c.querySelector('.btn__label')) === null || _d === void 0 ? void 0 : _d.textContent }, setConstructorProps)).use(pinia).mount(filterEl);
                    store.setValues(initialState.values);
                    store.updateValues();
                    store.restoreExpandedStateFromSession();
                    store.setLoaded();
                    state = __assign(__assign({}, initialState), { available: store.available, html: html, pagerHtml: pagerHtml, title: title });
                    window.history.replaceState(state, '', document.location.pathname + document.location.search);
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _e.sent();
                    console.error('Ошибка инициализации фильтра:', e_1);
                    return [3 /*break*/, 4];
                case 4:
                    EventBus.on('filter:page', function (data) {
                        api.updateResults(false, { page: data.page, pager: true, loadMore: data.isMoreButton });
                    });
                    EventBus.on('tab:change', function (event) {
                        var url = (store.sort.default !== store.sort.type ? "".concat(event.url, "?SORT=").concat(store.sort.type) : event.url);
                        store.config.md = event.code;
                        store.config.global = event.global;
                        store.config.url = url;
                        store.values = {};
                        updatePageTitle(event.pageTitle);
                        api.updateResults(true, { url: url, lockFilter: true })
                            .then(function () {
                            if (store.config.mode === 'BRAND') {
                                updateErrorMessage(event.global, event.code === 'NEW');
                            }
                        });
                    });
                    window.addEventListener('popstate', function (event) {
                        var state = event.state;
                        if (!(state && state.config && state.values && state.page)) {
                            return;
                        }
                        updatePageTitle(state.title);
                        if ((state.config.md && store.config.md) && store.config.md !== state.config.md) {
                            switchTabByCode(state.config.md, false);
                        }
                        store.setInitialState(state);
                        store.setSortType(state.config.sort);
                        store.updateAvailable(state.available || {});
                        if (state.html) {
                            updateHtml(state.html, false, state.pagerHtml);
                        }
                        else {
                            api.updateResults(true, { page: state.page, pushState: false });
                        }
                    });
                    return [2 /*return*/];
            }
        });
    });
}
